import http from 'common-module/src/util/http';

/**
 * 获取当前组织的saml配置（用于判断是否启用了SAML登录）
 */
export async function getSamlConfig() {
  const result = await http.get('/saml/current/get-config');
  return result;
}

/**
 * SP发起的SAML登出准备（失效token，返回state）
 */
export async function samlLogoutPrepare(platform) {
  const result = await http.post(`/saml/${platform}/logout-prepare`);
  return result;
}
